/**
 * Settings → Document Templates。
 * 打开页面打 STATSIG.COMMON.VIEW，value=settings_document_templates。
 *
 * 正在用：打开模板库；New template / Duplicate 落库（INSERT）；
 * 编辑后 Save（UPDATE）；Deactivate / Reactivate；设为 default。
 * 已不算：State 筛选、Sort、打开编辑器不存、Cancel。
 * 贷款 Documents tab 里建议 / 套用 / 发 request 不跨到这里。
 */
export enum SettingsDocumentTemplatesEvent {
    /**
     * New template 保存，或 Duplicate。
     * 属性 type=new|duplicate
     */
    INSERT = 'DOCUMENT_TEMPLATES_INSERT',
    /** 编辑已有模板后 Save */
    UPDATE = 'DOCUMENT_TEMPLATES_UPDATE',
    /**
     * Deactivate / Reactivate。
     * 属性 type=deactivate|reactivate
     */
    STATUS = 'DOCUMENT_TEMPLATES_STATUS',
    /** 设为 default */
    DEFAULT = 'DOCUMENT_TEMPLATES_DEFAULT',
}
